export default __webpack_public_path__ + "bookmark.b71a31eb.svg";